module.exports = __webpack_public_path__ + "assets/img/屏幕镜像.b4462a8b.png";